<template>
  <div class="molded-seat-step-six">

    <v-layout>
      <v-switch
          v-model="form.is_armrest_module_enabled"
          hide-details
          label="Accoudoirs :"
          class="mb-4 mt-2 title"
          @change="handleArmrestToggle"
        />
    </v-layout>


    <v-simple-table class="mb-5">
      <thead>
        <tr>
          <th class="text-center" />
          <th class="text-center">
            ACCOUDOIR
          </th>
          <th class="text-center">
            TYPE D'INSERT
          </th>
          <th class="text-center">
            POSITION
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>Droite</th>
          <td>
            <v-select
              v-model="form.armrest_module.right_orthosis_type"
              :items="armrestModule.right_orthosis_type"
              item-text="label"
              item-value="value"
              filled
              clearable
              hide-details
              :disabled="!form.is_armrest_module_enabled"
              @click:clear="
                $nextTick(
                  () => (form.armrest_module.right_orthosis_type = null)
                )
              "
            />
          </td>
          <td>
            <v-select
              v-model="form.armrest_module.right_insert_type"
              :items="armrestModule.right_insert_type"
              item-text="label"
              item-value="value"
              filled
              clearable
              hide-details
              :disabled="!form.is_armrest_module_enabled"
              @click:clear="
                $nextTick(() => (form.armrest_module.right_insert_type = null))
              "
            />
          </td>
          <td>
            <v-select
              v-model="form.armrest_module.right_position"
              :items="armrestModule.right_position"
              item-text="label"
              item-value="value"
              filled
              clearable
              hide-details
              :disabled="!form.is_armrest_module_enabled"
              @click:clear="
                $nextTick(() => (form.armrest_module.right_position = null))
              "
            />
          </td>
        </tr>

        <tr>
          <th>Gauche</th>
          <td>
            <v-select
              v-model="form.armrest_module.left_orthosis_type"
              :items="armrestModule.left_orthosis_type"
              item-text="label"
              item-value="value"
              filled
              clearable
              hide-details
              :disabled="!form.is_armrest_module_enabled"
              @click:clear="
                $nextTick(() => (form.armrest_module.left_orthosis_type = null))
              "
            />
          </td>
          <td>
            <v-select
              v-model="form.armrest_module.left_insert_type"
              :items="armrestModule.left_insert_type"
              item-text="label"
              item-value="value"
              filled
              clearable
              hide-details
              :disabled="!form.is_armrest_module_enabled"
              @click:clear="
                $nextTick(() => (form.armrest_module.left_insert_type = null))
              "
            />
          </td>
          <td>
            <v-select
              v-model="form.armrest_module.left_position"
              :items="armrestModule.left_position"
              item-text="label"
              item-value="value"
              filled
              clearable
              hide-details
              :disabled="!form.is_armrest_module_enabled"
              @click:clear="
                $nextTick(() => (form.armrest_module.left_position = null))
              "
            />
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-layout
      justify-center
      align-center
      class="mt-12"
    >
      <div class="content img1">
        <div class="img-container">
          <img
            class="mb-6"
            src="@/assets/img/schema_verticalisateur_3b.svg"
          >
          <v-text-field
            v-model="form.armrest_module.a"
            v-validate="'numeric|max:4'"
            :class="{ error: errors.has('(Accoudoirs) A') }"
            data-vv-name="(Accoudoirs) A"
            outlined
            type="number"
            style="top: 16.6%;left: 88.1%;"
            height="100%"
            :disabled="!form.is_armrest_module_enabled"
          />
          <v-text-field
            v-model="form.armrest_module.b"
            v-validate="'numeric|max:4'"
            :class="{ error: errors.has('(Accoudoirs) B') }"
            data-vv-name="(Accoudoirs) B"
            outlined
            type="number"
            style="top: 60.9%;left: 37%;"
            height="100%"
            :disabled="!form.is_armrest_module_enabled"
          />
        </div>
      </div>
    </v-layout>

    <v-textarea
      v-model="form.armrest_module.comment"
      filled
      name="Ajouter un commentaire :"
      label="Ajouter un commentaire :"
      :disabled="!form.is_armrest_module_enabled"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MoldedSeatStepSix",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      armrestModule: "dropdowns/getArmRestOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    handleArmrestToggle() {
      if (!this.form.is_armrest_module_enabled) {
        this.form.armrest_module = {
          right_orthosis_type: null,
          right_insert_type: null,
          right_position: null,
          left_orthosis_type: null,
          left_insert_type: null,
          left_position: null,
          finishing: null,
          a: null,
          b: null,
          comment: null
        };
      }
    }
  }
};
</script>

<style lang="scss">
.molded-seat-step-six {
  .content {
    display: flex;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
    &.img1 {
      .img-container {
        .v-input {
          width: 11.8%;
          height: 18.8%;
        }
      }
    }
    &.img2 {
      .img-container {
        .v-input {
          width: 11.8%;
          height: 21.8%;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      .v-label {
        align-items: baseline;
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        transform: none;
        margin-left: 15px;
        max-width: none !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .sm6 {
    flex-basis: calc(100% / 2 - 7px);
  }
}
</style>
